module.exports = __webpack_public_path__ + "media/images/pc/top/keyword_pet@3x-fc9355707c604e8b746f68f8821e091b.webp";